import React, {Component} from "react";

import '../../../../assets/sass/pages/matches-and-events/events.scss';
import EventsFilters from "./filters/EventsFilters";
import MatchesEvents from "./events/MatchesEvents";
import MatchesResults from "./results/MatchesResults";

class Events extends Component {
    state = {
        search: null,
        regions: [],
        countries: [],
    };

    render = () => {
        return (
            <div className="results">
                {this.renderFilters()}
                {this.renderEvents()}
            </div>
        );
    };

    renderFilters = () => {
        return (
            <EventsFilters onChange={this.handleFiltersChange}/>
        );
    };

    renderEvents = () => {
        const {regions, countries, search} = this.state;

        return (
            <MatchesEvents search={search} regions={regions} countries={countries}/>
        );
    };


    handleFiltersChange = options => this.setState({
        regions: options?.regions?.map(item => item.value),
        countries: options?.countries?.map(item => item.value),
        search: options?.search,
    });
}


export default Events;
